export default[
    {
        field: 'acc_account_id',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Tipo de Cuenta',
        },
        options: {
            data: [],
            text: 'comment',
            value: 'id',
        },
        rules: [ 'required' ],
        value: '',
    },
]
